import * as type from '@app/constants/scenes/zWaveDevices/sensorNotifications'

type State = {
  devices: Array<{ notification_type: number, notification_name: string, event_type: Array<{ type: number, name: string }> }>,
}
const initialState = {
  devices: [],
}

export default function sensorNotifications(state: State = initialState, action: Object): State {
  switch (action.type) {
  case type.UPDATE_SENSOR_NOTIFICATIONS: {
    return {
      ...state,
      devices: action.sensorNotifications,
    }
  }

  default:
    return state
  }
}
